/**
 * Staging / production builds set VITE_DEFAULT_NETWORK_ID to a mainnet chain.
 * That is the signal to expose Avalanche C-Chain + COTI Mainnet instead of
 * Sepolia + Fuji + COTI Testnet.
 *
 * Accept COTI Mainnet, Avalanche C-Chain, or Ethereum — local testing often
 * defaults to `0xa86a` while staging deploys use `0x282b34`.
 */
export const COTI_MAINNET_HEX = '0x282b34';
export const AVALANCHE_C_HEX = '0xa86a';
export const ETHEREUM_MAINNET_HEX = '0x1';

const MAINNET_PORTAL_DEFAULTS = new Set([
  COTI_MAINNET_HEX,
  AVALANCHE_C_HEX,
  ETHEREUM_MAINNET_HEX,
]);

export function isMainnetPortalBuild(): boolean {
  const envId = (import.meta.env.VITE_DEFAULT_NETWORK_ID as string | undefined)?.toLowerCase();
  return envId != null && MAINNET_PORTAL_DEFAULTS.has(envId);
}
